import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "home-wage-savings-modal" }
const _hoisted_2 = { class: "home-wage-savings-modal__head" }
const _hoisted_3 = { class: "home-wage-savings-modal__toolbar" }
const _hoisted_4 = { class: "home-wage-savings-modal__year-label" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "home-wage-savings-modal__cards" }
const _hoisted_7 = { class: "home-wage-savings-modal__card" }
const _hoisted_8 = { class: "home-wage-savings-modal__card-label" }
const _hoisted_9 = { class: "home-wage-savings-modal__card-value" }
const _hoisted_10 = { class: "home-wage-savings-modal__card" }
const _hoisted_11 = { class: "home-wage-savings-modal__card-label" }
const _hoisted_12 = { class: "home-wage-savings-modal__card-value" }
const _hoisted_13 = { class: "home-wage-savings-modal__card home-wage-savings-modal__card--accent" }
const _hoisted_14 = { class: "home-wage-savings-modal__card-value" }
const _hoisted_15 = {
  key: 0,
  class: "home-wage-savings-modal__chart-wrap"
}
const _hoisted_16 = { class: "home-wage-savings-modal__chart-title" }
const _hoisted_17 = { class: "home-wage-savings-modal__chart" }
const _hoisted_18 = { class: "home-wage-savings-modal__bar-area" }
const _hoisted_19 = ["title"]
const _hoisted_20 = { class: "home-wage-savings-modal__bar-label" }
const _hoisted_21 = {
  key: 1,
  class: "home-wage-savings-modal__empty"
}
const _hoisted_22 = {
  key: 2,
  class: "home-wage-savings-modal__table-wrap"
}
const _hoisted_23 = { class: "home-wage-savings-modal__table" }
const _hoisted_24 = { class: "home-wage-savings-modal__footer" }
const _hoisted_25 = { class: "home-wage-savings-modal__head" }
const _hoisted_26 = { class: "home-wage-savings-modal__head-left" }
const _hoisted_27 = { class: "home-wage-savings-modal__toolbar home-wage-savings-modal__toolbar--detail" }
const _hoisted_28 = { class: "home-wage-savings-modal__year-label" }
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "home-wage-savings-modal__year-label" }
const _hoisted_31 = ["value"]
const _hoisted_32 = {
  key: 0,
  class: "home-wage-savings-modal__detail-summary"
}
const _hoisted_33 = { class: "home-wage-savings-modal__detail-summary-total" }
const _hoisted_34 = {
  key: 1,
  class: "home-wage-savings-modal__table-wrap home-wage-savings-modal__table-wrap--detail"
}
const _hoisted_35 = { class: "home-wage-savings-modal__table home-wage-savings-modal__table--detail" }
const _hoisted_36 = ["rowspan"]
const _hoisted_37 = ["rowspan"]
const _hoisted_38 = { class: "home-wage-savings-modal__cell-label" }
const _hoisted_39 = { class: "home-wage-savings-modal__cell-amount" }
const _hoisted_40 = { class: "home-wage-savings-modal__cell-saving" }
const _hoisted_41 = {
  key: 2,
  class: "home-wage-savings-modal__empty"
}
const _hoisted_42 = { class: "home-wage-savings-modal__footer" }

import { computed, ref, watch } from 'vue';
import LoadingOverlay from '@/components/common/LoadingOverlay.vue';
import { formatWageNumber } from '@/composables/wage/useWageCalculator';
import {
  fetchHomeWageMonthSaving,
  fetchHomeWageNontaxSavingsReport,
  fetchHomeWageEmployeeSavingsDetail,
  flattenEmployeeSavingsDetails,
  buildJoinDateMapFromEmployees,
  type HomeWageNontaxSavingsMonthRow,
  type HomeWageEmployeeSavingsDetailRow,
} from '@/composables/wage/useHomeWageNontaxSavingsReport';


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeWageNontaxSavingsModal',
  props: {
    mCode: {},
    bizGubun: {},
    focusYear: {},
    focusMonth: {},
    employees: {},
    isAdmin: { type: Boolean }
  },
  emits: ["update:monthSaving", "update:loadingMonthSaving"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const dialog = ref(false);
const loading = ref(false);
const detailLoading = ref(false);
const viewMode = ref<'summary' | 'detail'>('summary');
const viewYear = ref(props.focusYear);
const detailYear = ref(props.focusYear);
const detailMonth = ref(props.focusMonth);
const focusMonthSaving = ref(0);
const yearTotal = ref(0);
const cumulativeTotal = ref(0);
const monthly = ref<HomeWageNontaxSavingsMonthRow[]>([]);
const detailRows = ref<HomeWageEmployeeSavingsDetailRow[]>([]);

const focusYear = computed(() => props.focusYear);
const focusMonth = computed(() => props.focusMonth);
const isAdmin = computed(() => props.isAdmin === true);

const availableYears = computed(() => {
  const current = new Date().getFullYear();
  const years: number[] = [];
  for (let y = current; y >= 2020; y -= 1) years.push(y);
  return years;
});

const focusMonthLabel = computed(() => {
  if (viewYear.value === props.focusYear) {
    return `${props.focusYear}.${String(props.focusMonth).padStart(2, '0')}`;
  }
  return `${viewYear.value}년`;
});

const detailEmployeeCount = computed(() => {
  const names = new Set(detailRows.value.filter((r) => r.isFirstLine).map((r) => r.name));
  return names.size;
});

const detailMonthTotal = computed(() =>
  detailRows.value.filter((r) => r.isFirstLine).reduce((sum, r) => sum + r.employeeTotalSaving, 0)
);

const maxBarSaving = computed(() =>
  Math.max(...monthly.value.filter((m) => m.hasData).map((m) => m.saving), 1)
);

const barHeight = (saving: number) => {
  const pct = Math.max(4, Math.round((saving / maxBarSaving.value) * 100));
  return `${pct}%`;
};

const joinDateByKey = computed(() => buildJoinDateMapFromEmployees(props.employees ?? []));

const loadFocusMonthSaving = async () => {
  if (!props.mCode) {
    focusMonthSaving.value = 0;
    emit('update:monthSaving', null);
    return;
  }
  emit('update:loadingMonthSaving', true);
  try {
    const result = await fetchHomeWageMonthSaving({
      mCode: props.mCode,
      bizGubun: props.bizGubun || '',
      year: props.focusYear,
      month: props.focusMonth,
      joinDateByKey: joinDateByKey.value,
    });
    focusMonthSaving.value = result.saving;
    emit('update:monthSaving', result.hasData ? result.saving : 0);
  } catch (error: unknown) {
    const message =
      (error as { response?: { data?: { message?: string } } })?.response?.data?.message ||
      (error as Error)?.message ||
      '알 수 없는 오류';
    alert(`당월 절감액 조회 실패: ${message}`);
    emit('update:monthSaving', null);
  } finally {
    emit('update:loadingMonthSaving', false);
  }
};

const loadReport = async () => {
  if (!props.mCode) return;
  loading.value = true;
  try {
    const result = await fetchHomeWageNontaxSavingsReport({
      mCode: props.mCode,
      bizGubun: props.bizGubun || '',
      year: viewYear.value,
      joinDateByKey: joinDateByKey.value,
    });
    monthly.value = result.yearReport.monthly;
    yearTotal.value = result.yearReport.yearTotal;
    cumulativeTotal.value = result.cumulativeTotal;
  } catch (error: unknown) {
    const message =
      (error as { response?: { data?: { message?: string } } })?.response?.data?.message ||
      (error as Error)?.message ||
      '알 수 없는 오류';
    alert(`절감 현황 조회 실패: ${message}`);
    monthly.value = [];
    yearTotal.value = 0;
    cumulativeTotal.value = 0;
  } finally {
    loading.value = false;
  }
};

const loadEmployeeDetail = async () => {
  if (!props.mCode || !isAdmin.value) return;
  detailLoading.value = true;
  try {
    const details = await fetchHomeWageEmployeeSavingsDetail({
      mCode: props.mCode,
      bizGubun: props.bizGubun || '',
      year: detailYear.value,
      month: detailMonth.value,
      joinDateByKey: joinDateByKey.value,
    });
    detailRows.value = flattenEmployeeSavingsDetails(details);
  } catch (error: unknown) {
    const message =
      (error as { response?: { data?: { message?: string } } })?.response?.data?.message ||
      (error as Error)?.message ||
      '알 수 없는 오류';
    alert(`사원별 상세 조회 실패: ${message}`);
    detailRows.value = [];
  } finally {
    detailLoading.value = false;
  }
};

const openDetailView = async () => {
  if (!isAdmin.value) return;
  detailYear.value = viewYear.value;
  detailMonth.value =
    viewYear.value === props.focusYear ? props.focusMonth : 1;
  viewMode.value = 'detail';
  await loadEmployeeDetail();
};

const open = async () => {
  viewYear.value = props.focusYear;
  viewMode.value = 'summary';
  dialog.value = true;
  await loadReport();
};

const close = () => {
  dialog.value = false;
  viewMode.value = 'summary';
};

watch(
  () => [props.mCode, props.bizGubun, props.focusYear, props.focusMonth, props.employees?.length],
  () => {
    if (props.mCode) loadFocusMonthSaving();
  },
  { immediate: true }
);

__expose({ open, loadFocusMonthSaving, focusMonthSaving });

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dialog).value = $event)),
    "max-width": "720",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(LoadingOverlay, {
          show: loading.value || detailLoading.value,
          text: "불러오는 중..."
        }, null, 8, ["show"]),
        (viewMode.value === 'summary')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("header", _hoisted_2, [
                _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "home-wage-savings-modal__title" }, "인건비 절감 현황", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "home-wage-savings-modal__close",
                  "aria-label": "닫기",
                  onClick: close
                }, [
                  _createVNode(_component_v_icon, { size: "18" }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode("mdi-close", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("section", _hoisted_3, [
                _createElementVNode("label", _hoisted_4, [
                  _cache[7] || (_cache[7] = _createElementVNode("span", null, "조회 연도", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((viewYear).value = $event)),
                    class: "home-wage-savings-modal__year-select",
                    onChange: loadReport
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableYears.value, (y) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: y,
                        value: y
                      }, _toDisplayString(y) + "년", 9, _hoisted_5))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, viewYear.value]
                  ])
                ])
              ]),
              _createElementVNode("section", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(focusMonthLabel.value) + " 절감", 1),
                  _createElementVNode("span", _hoisted_9, [
                    _createTextVNode(_toDisplayString(_unref(formatWageNumber)(focusMonthSaving.value)), 1),
                    _cache[8] || (_cache[8] = _createElementVNode("small", null, "원", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(viewYear.value) + "년 합계", 1),
                  _createElementVNode("span", _hoisted_12, [
                    _createTextVNode(_toDisplayString(_unref(formatWageNumber)(yearTotal.value)), 1),
                    _cache[9] || (_cache[9] = _createElementVNode("small", null, "원", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _cache[11] || (_cache[11] = _createElementVNode("span", { class: "home-wage-savings-modal__card-label" }, "누적 절감", -1)),
                  _createElementVNode("span", _hoisted_14, [
                    _createTextVNode(_toDisplayString(_unref(formatWageNumber)(cumulativeTotal.value)), 1),
                    _cache[10] || (_cache[10] = _createElementVNode("small", null, "원", -1))
                  ])
                ])
              ]),
              (monthly.value.length)
                ? (_openBlock(), _createElementBlock("section", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, _toDisplayString(viewYear.value) + "년 월별 절감", 1),
                    _createElementVNode("div", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(monthly.value, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.month,
                          class: "home-wage-savings-modal__bar-col"
                        }, [
                          _createElementVNode("div", _hoisted_18, [
                            (item.hasData)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: _normalizeClass(["home-wage-savings-modal__bar", { 'home-wage-savings-modal__bar--focus': item.month === focusMonth.value && viewYear.value === focusYear.value }]),
                                  style: _normalizeStyle({ height: barHeight(item.saving) }),
                                  title: `${item.month}월 ${_unref(formatWageNumber)(item.saving)}원`
                                }, null, 14, _hoisted_19))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("span", _hoisted_20, _toDisplayString(item.month) + "월", 1)
                        ]))
                      }), 128))
                    ])
                  ]))
                : (!loading.value)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_21, _toDisplayString(viewYear.value) + "년 급여대장 데이터가 없습니다. ", 1))
                  : _createCommentVNode("", true),
              (monthly.value.some((m) => m.hasData))
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("table", _hoisted_23, [
                      _cache[12] || (_cache[12] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, "월"),
                          _createElementVNode("th", null, "대상"),
                          _createElementVNode("th", null, "월 절감"),
                          _createElementVNode("th", null, "연간 누적")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(monthly.value, (item) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: `row-${item.month}`,
                            class: _normalizeClass({ 'home-wage-savings-modal__row--empty': !item.hasData })
                          }, [
                            _createElementVNode("td", null, _toDisplayString(item.month) + "월", 1),
                            _createElementVNode("td", null, _toDisplayString(item.hasData ? `${item.employeeCount}명` : '-'), 1),
                            _createElementVNode("td", null, _toDisplayString(item.hasData ? `${_unref(formatWageNumber)(item.saving)}원` : '-'), 1),
                            _createElementVNode("td", null, _toDisplayString(item.hasData ? `${_unref(formatWageNumber)(item.cumulative)}원` : '-'), 1)
                          ], 2))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("footer", _hoisted_24, [
                (isAdmin.value)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      variant: "flat",
                      class: "btn-edit home-wage-savings-modal__admin-btn",
                      size: "small",
                      onClick: openDetailView
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { size: "14" }, {
                          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                            _createTextVNode("mdi-account-search", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[14] || (_cache[14] = _createTextVNode(" 사원별 상세 ", -1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  class: "btn-close",
                  size: "small",
                  onClick: close
                }, {
                  default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                    _createTextVNode("닫기", -1)
                  ]))]),
                  _: 1
                })
              ])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("header", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "home-wage-savings-modal__back",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (viewMode.value = 'summary'))
                  }, [
                    _createVNode(_component_v_icon, { size: "16" }, {
                      default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                        _createTextVNode("mdi-arrow-left", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[17] || (_cache[17] = _createTextVNode(" 돌아가기 ", -1))
                  ]),
                  _cache[18] || (_cache[18] = _createElementVNode("h3", { class: "home-wage-savings-modal__title" }, "사원별 비과세 절감", -1))
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "home-wage-savings-modal__close",
                  "aria-label": "닫기",
                  onClick: close
                }, [
                  _createVNode(_component_v_icon, { size: "18" }, {
                    default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                      _createTextVNode("mdi-close", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("section", _hoisted_27, [
                _createElementVNode("label", _hoisted_28, [
                  _cache[20] || (_cache[20] = _createElementVNode("span", null, "연도", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((detailYear).value = $event)),
                    class: "home-wage-savings-modal__year-select",
                    onChange: loadEmployeeDetail
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableYears.value, (y) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: `d-${y}`,
                        value: y
                      }, _toDisplayString(y) + "년", 9, _hoisted_29))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, detailYear.value]
                  ])
                ]),
                _createElementVNode("label", _hoisted_30, [
                  _cache[21] || (_cache[21] = _createElementVNode("span", null, "월", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((detailMonth).value = $event)),
                    class: "home-wage-savings-modal__year-select",
                    onChange: loadEmployeeDetail
                  }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (m) => {
                      return _createElementVNode("option", {
                        key: m,
                        value: m
                      }, _toDisplayString(m) + "월", 9, _hoisted_31)
                    }), 64))
                  ], 544), [
                    [_vModelSelect, detailMonth.value]
                  ])
                ]),
                _cache[22] || (_cache[22] = _createElementVNode("span", { class: "home-wage-savings-modal__detail-badge" }, "관리자 전용", -1))
              ]),
              (detailRows.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _createElementVNode("span", null, _toDisplayString(detailYear.value) + "." + _toDisplayString(String(detailMonth.value).padStart(2, '0')), 1),
                    _createElementVNode("span", null, _toDisplayString(detailEmployeeCount.value) + "명", 1),
                    _createElementVNode("span", _hoisted_33, "합계 " + _toDisplayString(_unref(formatWageNumber)(detailMonthTotal.value)) + "원", 1)
                  ]))
                : _createCommentVNode("", true),
              (detailRows.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _createElementVNode("table", _hoisted_35, [
                      _cache[24] || (_cache[24] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, "사원명"),
                          _createElementVNode("th", null, "직종"),
                          _createElementVNode("th", null, "비과세 항목"),
                          _createElementVNode("th", null, "비과세액"),
                          _createElementVNode("th", null, "절감액")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailRows.value, (row, idx) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: `detail-${row.name}-${row.nontaxLabel}-${idx}`
                          }, [
                            (row.isFirstLine)
                              ? (_openBlock(), _createElementBlock("td", {
                                  key: 0,
                                  rowspan: row.lineCount,
                                  class: "home-wage-savings-modal__cell-name"
                                }, _toDisplayString(row.name), 9, _hoisted_36))
                              : _createCommentVNode("", true),
                            (row.isFirstLine)
                              ? (_openBlock(), _createElementBlock("td", {
                                  key: 1,
                                  rowspan: row.lineCount,
                                  class: "home-wage-savings-modal__cell-job"
                                }, _toDisplayString(row.job || '-'), 9, _hoisted_37))
                              : _createCommentVNode("", true),
                            _createElementVNode("td", _hoisted_38, _toDisplayString(row.nontaxLabel), 1),
                            _createElementVNode("td", _hoisted_39, _toDisplayString(_unref(formatWageNumber)(row.nontaxAmount)) + "원", 1),
                            _createElementVNode("td", _hoisted_40, _toDisplayString(_unref(formatWageNumber)(row.savingAmount)) + "원", 1)
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("tfoot", null, [
                        _createElementVNode("tr", null, [
                          _cache[23] || (_cache[23] = _createElementVNode("td", { colspan: "4" }, "월 합계", -1)),
                          _createElementVNode("td", null, _toDisplayString(_unref(formatWageNumber)(detailMonthTotal.value)) + "원", 1)
                        ])
                      ])
                    ])
                  ]))
                : (!detailLoading.value)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_41, " 해당 월 비과세 절감 내역이 없습니다. "))
                  : _createCommentVNode("", true),
              _createElementVNode("footer", _hoisted_42, [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  class: "btn-close",
                  size: "small",
                  onClick: close
                }, {
                  default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                    _createTextVNode("닫기", -1)
                  ]))]),
                  _: 1
                })
              ])
            ], 64))
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})